import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TeamRegistration.css';

const MOCK_TOURNAMENTS = [
  { id: 1, title: 'Turniej Wiosenny Cup 2025', date: '15.02.2026', organizer: 'Legia Warszawa' },
  { id: 2, title: 'Liga Młodych Talentów', date: '08.03.2026', organizer: 'Wisła Kraków' },
  { id: 3, title: 'Puchar Bałtyku', date: '22.04.2026', organizer: 'Lechia Gdańsk' },
  { id: 4, title: 'Junior Football Festival', date: '10.05.2026', organizer: 'Lech Poznań' },
  { id: 5, title: 'Orlik Masters', date: '03.06.2026', organizer: 'Śląsk Wrocław' },
  { id: 6, title: 'Górski Turniej Piłkarski', date: '18.06.2026', organizer: 'Pogoń Szczecin' },
  { id: 7, title: 'Śląska Liga Juniorów', date: '05.07.2026', organizer: 'Górnik Zabrze' },
  { id: 8, title: 'Turniej Niepodległości', date: '21.07.2026', organizer: 'Motor Lublin' },
  { id: 9, title: 'Nadmorski Cup', date: '14.08.2026', organizer: 'Pogoń Szczecin' },
  { id: 10, title: 'Akademia Futbolu Open', date: '29.08.2026', organizer: 'Widzew Łódź' },
  { id: 11, title: 'Turniej Gwiazd', date: '12.09.2026', organizer: 'Jagiellonia Białystok' },
  { id: 12, title: 'Mini Euro Championship', date: '26.09.2026', organizer: 'Stal Mielec' },
  { id: 13, title: 'Puchar Młodych Orłów', date: '11.10.2026', organizer: 'Raków Częstochowa' },
  { id: 14, title: 'Football Kids Festival', date: '24.10.2026', organizer: 'Piast Gliwice' },
  { id: 15, title: 'Wielkopolska Junior League', date: '07.11.2026', organizer: 'Lech Poznań' }
];

function TeamRegistration() {
  const { id } = useParams();
  const navigate = useNavigate();

  const tournament = MOCK_TOURNAMENTS.find(t => t.id === parseInt(id));

  const [formData, setFormData] = useState({
    teamName: '',
    contactPerson: '',
    email: '',
    phone: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  if (!tournament) {
    return (
      <div className="registration-container">
        <div className="registration-card">
          <h1>Turniej nie został znaleziony</h1>
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            Wróć do wyszukiwarki
          </button>
        </div>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className="registration-container">
        <div className="registration-card">
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h1>Dziękujemy za zgłoszenie!</h1>
            <p>Twoja drużyna <strong>{formData.teamName}</strong> została zgłoszona do turnieju <strong>{tournament.title}</strong>.</p>
            <p>Potwierdzenie zostanie wysłane na adres: <strong>{formData.email}</strong></p>
            <div className="success-actions">
              <button className="btn btn-secondary" onClick={() => navigate(`/tournament/${id}`)}>
                Wróć do turnieju
              </button>
              <button className="btn btn-primary" onClick={() => navigate('/')}>
                Szukaj innych turniejów
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="registration-container">
      <div className="registration-card">
        <button className="btn btn-back" onClick={() => navigate(`/tournament/${id}`)}>
          ← Wróć do szczegółów turnieju
        </button>

        <div className="registration-header">
          <h1>Zapisz drużynę</h1>
          <p>Formularz zgłoszeniowy do turnieju</p>
        </div>

        <div className="tournament-summary">
          <h2>{tournament.title}</h2>
          <p>Organizator: {tournament.organizer} | Data: {tournament.date}</p>
        </div>

        <form onSubmit={handleSubmit} className="registration-form">
          <div className="form-group">
            <label htmlFor="teamName">
              <span className="label-icon">⚽</span>
              Nazwa drużyny
            </label>
            <input
              type="text"
              id="teamName"
              name="teamName"
              value={formData.teamName}
              onChange={handleChange}
              placeholder="Wprowadź nazwę drużyny"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contactPerson">
              <span className="label-icon">👤</span>
              Osoba kontaktowa
            </label>
            <input
              type="text"
              id="contactPerson"
              name="contactPerson"
              value={formData.contactPerson}
              onChange={handleChange}
              placeholder="Imię i nazwisko"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              <span className="label-icon">📧</span>
              Adres email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="email@przykład.pl"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">
              <span className="label-icon">📞</span>
              Telefon
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+48 123 456 789"
              required
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={() => navigate(`/tournament/${id}`)}>
              Anuluj
            </button>
            <button type="submit" className="btn btn-primary">
              Zapisz drużynę
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TeamRegistration;
